import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./App";
import { DialogProvider } from "./components/Dialog";
import { UpdaterRoot } from "./components/UpdaterDialog";
import { I18nProvider } from "./lib/i18n";
import { initTheme } from "./lib/theme";
import { AuthProvider } from "./lib/use-auth";
import "./styles/global.css";

// 启动前先应用主题（避免登录页白屏闪一下）
initTheme();

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing");

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <DialogProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          {/* D1: 自动更新弹窗 (Tauri 桌面端才会实际触发, Web 端 isTauriDesktop()=false no-op) */}
          <UpdaterRoot />
        </AuthProvider>
      </DialogProvider>
    </I18nProvider>
  </StrictMode>,
);
